import { contract } from './contract';

export const undef = contract<undefined>('undefined');
